<template>
  <div>
    <img src="/static/img/yatay.png" style="width: 0px; height: 0px" alt="" />
    <img src="/static/img/dikey.png" style="width: 0px; height: 0px" alt="" />
    <el-drawer
      :destroy-on-close="true"
      :append-to-body="true"
      title="Ayarlar"
      :visible.sync="settings"
      :with-header="false"
    >
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label for="">{{ $t("module.speed") }}</label>
          <el-slider
            v-model="speed"
            :step="1"
            :min="1"
            :max="speeds.length"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12">
          <label class="dark-inverted d-block" for="">{{
            $t("module.direction")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="direction"
            :active-text="$t('module.horizontal')"
            :active-value="'yatay'"
            :inactive-value="'dikey'"
            :inactive-text="$t('module.vertical')"
          >
          </el-switch>
        </div>
        <div class="col-md-12">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="autoLevel"
            :active-text="$t('module.yes')"
            :active-value="1"
            :inactive-value="0"
            :inactive-text="$t('module.no')"
          >
          </el-switch>
        </div>
        <div class="col-md-12">
          <label class="dark-inverted d-block" for="">{{
            $t("module.attention")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="questionMode"
            :active-text="$t('module.open')"
            :active-value="1"
            :inactive-value="0"
            :inactive-text="$t('module.close')"
          >
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div
      id="goz_esnetme"
      :style="{
        backgroundImage:
          questionMode == 1 &&
          (questionStatus == 'wait' || questionStatus == 'end')
            ? ''
            : direction == 'yatay'
            ? 'url(/static/img/yatay.png)'
            : 'url(/static/img/dikey.png)',
      }"
    >
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>
      <a
        href="javascript:;"
        v-if="config == null || config == undefined"
        @click.stop="settings = true"
        class="settings"
      >
        <i class="el-icon-setting"></i>
      </a>
      <div
        v-if="
          questionMode == 0 ||
          (questionMode == 1 && questionStatus == 'started')
        "
        style="
          width: 20px;
          height: 20px;
          background: orange;
          border-radius: 50%;
          position: absolute;
        "
        :style="{
          top: top + 'px',
          left: left + 'px',
          background: questionMode == 1 ? currentColor : 'orange',
        }"
      ></div>
      <div
        v-if="questionMode == 1 && questionStatus == 'wait'"
        style="
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          font-size: 22px;
          padding: 20px;
          flex-direction: column;
        "
        class="dark-inverted"
      >
        <div
          :style="{
            background: levels[level - 1].colors[levels[level - 1].target],
          }"
          style="width: 20px; height: 20px; border-radius: 50%"
        />
        <p
          v-html="
            $t('module.zikzak.dikkat', { time: levels[level - 1].counter })
          "
        ></p>
        <el-button round type="primary" @click.stop="start">{{
          $t("module.start")
        }}</el-button>
      </div>
      <div
        v-if="questionMode == 1 && questionStatus == 'end'"
        style="
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          font-size: 22px;
          padding: 20px;
          flex-direction: column;
        "
        class="dark-inverted"
      >
        <div
          :style="{
            background: levels[level - 1].colors[levels[level - 1].target],
          }"
          style="width: 20px; height: 20px; border-radius: 50%"
        />
        <p v-html="$t('module.zikzak.desc')"></p>
        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            class="dark-inverted"
            v-for="(item, index) in options"
            @click="pick(item, index)"
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              font-size: 20;
              padding: 10px 15px;
              cursor: pointer;
            "
            :style="{
              background: item.picked ? (item.isTrue ? 'blue' : 'red') : '',
              color: item.picked ? (item.isTrue ? 'white' : 'white') : '',
            }"
          >
            {{ item.option }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="questionMode == 15778"
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
        width: 700px;
        margin: 0 auto;
        margin-top: 10px;
      "
    >
      <span class="dark-inverted">
        <span
          v-if="questionStatus == 'started'"
          style="font-size: 25px; font-weight: bold"
          class="dark-inverted true-count"
          >{{
            moment("2021-01-01 00:00:00")
              .add({ seconds: questionCounter })
              .format("mm:ss")
          }}</span
        >
      </span>
      <div style="display: flex; flex-direction: row">
        <span
          class="num"
          style="display: flex; align-items: center; justify-content: center"
        >
          <div
            style="
              position: relative;
              z-index: 9999;
              background-color: red;
              width: 40px;
              height: 40px;
              border-radius: 50%;
              color: white;
              align-items: center;
              justify-content: center;
              display: flex;
              font-size: 22px;
            "
          >
            <i class="fas fa-times"></i>
          </div>
          <span
            style="
              font-size: 35px;
              font-weight: bold;
              color: white;
              background: red;
              height: 40px;
              padding-left: 20px;
              margin-left: -20px;
              z-index: 1;
              position: relative;
              line-height: 45px;
              padding-right: 10px;
            "
            >{{ totalFalse }}</span
          >
        </span>
        <span
          class="num"
          style="display: flex; align-items: center; justify-content: center"
        >
          <span
            style="
              font-size: 35px;
              font-weight: bold;
              color: white;
              background: rgb(28, 68, 156);
              height: 40px;
              padding-right: 20px;
              margin-right: -20px;
              z-index: 0;
              position: relative;
              line-height: 45px;
              padding-left: 10px;
            "
            >{{ totalTrue }}</span
          >
        </span>
        <svg
          height="40px"
          viewBox="0 0 512 512"
          width="40px"
          xmlns="http://www.w3.org/2000/svg"
          style="position: relative; z-index: 2"
        >
          <path
            d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0"
            fill="rgb(28, 68, 156)"
          />
          <path
            d="m385.75 201.75-138.667969 138.664062c-4.160156 4.160157-9.621093 6.253907-15.082031 6.253907s-10.921875-2.09375-15.082031-6.253907l-69.332031-69.332031c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339843-8.34375 21.820312-8.34375 30.164062 0l54.25 54.25 123.585938-123.582031c8.339843-8.34375 21.820312-8.34375 30.164062 0 8.339844 8.339843 8.339844 21.820312 0 30.164062zm0 0"
            fill="#fafafa"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
export default {
  name: "GozEsnekligi",
  props: ["config"],
  data() {
    return {
      pause: false,
      speed: 1,
      speeds: [500, 461, 428, 400, 375, 352, 333],
      word: null,
      moment,
      rotate: 0,
      currentCounter: 30,
      startCounter: 5,
      wrapper: {
        width: 0,
        height: 0,
      },
      settings: false,
      maxStep: 10,
      step: 1,
      direction: "dikey",
      currentColor: "orange",
      directions: {
        yatay: [
          {
            top: 241,
            left: 27,
          },
          {
            top: 46,
            left: 72,
          },
          {
            top: 199,
            left: 118,
          },
          {
            top: 46,
            left: 164,
          },
          {
            top: 199,
            left: 210,
          },
          {
            top: 46,
            left: 254,
          },
          {
            top: 199,
            left: 300,
          },
          {
            top: 46,
            left: 346,
          },
          {
            top: 199,
            left: 392,
          },
          {
            top: 46,
            left: 438,
          },
          {
            top: 199,
            left: 484,
          },
          {
            top: 46,
            left: 530,
          },
          {
            top: 199,
            left: 576,
          },
          {
            top: 46,
            left: 622,
          },
          {
            top: 241,
            left: 667,
          }, // basla
          {
            top: 434,
            left: 623,
          },
          {
            top: 281,
            left: 577,
          },
          {
            top: 434,
            left: 531,
          },
          {
            top: 281,
            left: 485,
          },
          {
            top: 434,
            left: 439,
          },
          {
            top: 281,
            left: 393,
          },
          {
            top: 434,
            left: 347,
          },
          {
            top: 281,
            left: 301,
          },
          {
            top: 434,
            left: 255,
          },
          {
            top: 281,
            left: 209,
          },
          {
            top: 434,
            left: 163,
          },
          {
            top: 281,
            left: 117,
          },
          {
            top: 434,
            left: 71,
          },
          {
            top: 241,
            left: 27,
          },
        ],
        dikey: [
          {
            top: 39,
            left: 97,
          },
          {
            top: 39,
            left: 597,
          }, // basla
          {
            top: 105,
            left: 144,
          },
          {
            top: 105,
            left: 597,
          },
          {
            top: 171,
            left: 144,
          },
          {
            top: 171,
            left: 597,
          },
          {
            top: 237 + 3,
            left: 144,
          },
          {
            top: 237 + 3,
            left: 597,
          },
          {
            top: 303 + 3,
            left: 144,
          },
          {
            top: 303 + 3,
            left: 597,
          },
          {
            top: 369 + 3,
            left: 144,
          },
          {
            top: 369 + 5,
            left: 597,
          },
          {
            top: 435 + 5,
            left: 97,
          },
          {
            top: 39,
            left: 97,
          },
        ],
      },
      autoLevel: 0,
      tourCount: 0,
      levels: [],
      colors: [
        "#FD8D00",
        "#A020F0",
        "#05C3DD",
        "#F50000",
        "#A6A5A0",
        "#5FB924",
      ],
      questionMode: 0,
      questionInterval: null,
      questionCounter: null,
      questionStatus: null,
      level: 1,
      options: [],
      totalTrue: 0,
      totalFalse: 0,
      answerStack: [],
    };
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
    this.start();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.questionInterval);
    this.interval = null;
    this.questionInterval = null;
  },
  methods: {
    pick(item, index) {
      if (this.lock || item.picked) return;
      this.options[index].picked = true;
      if (item.isTrue) {
        this.answerStack.push(true);
        this.totalTrue += 1;
        new Audio("/static/correct.mp3").play();
      } else {
        new Audio("/static/incorrect.mp3").play();
        if (this.pickRemain > 0) {
          this.pickRemain -= 1;
          return;
        }
        var index2 = this.options.findIndex(
          (k) => k.option == this.levels[this.level - 1].viewCount
        );
        this.options[index2].picked = true;
        this.totalFalse += 1;
        this.answerStack.push(false);
      }

      setTimeout(() => {
        if (this.config != null && this.config != undefined) {
          this.$root.$emit("done");
          return;
        }
        this.options = [];
        this.questionStatus = "wait";
        this.pickRemain = 1;
        this.lock = false;
        this.initLevels();
      }, 1000);
    },
    initLevels() {
      this.levels = [
        {
          counter: 30,
          target: _.random(0, 1),
          viewCount: 0,
          colors: _.shuffle(this.colors).slice(0, 2),
          min: 9,
          max: 19,
          maxViewLimit: _.random(9, 19),
        },
        {
          counter: 30,
          target: _.random(0, 1),
          viewCount: 0,
          colors: _.shuffle(this.colors).slice(0, 2),
          min: 13,
          max: 23,
          maxViewLimit: _.random(13, 23),
        },
        {
          counter: 45,
          target: _.random(0, 2),
          viewCount: 0,
          colors: _.shuffle(this.colors).slice(0, 3),
          min: 11,
          max: 21,
          maxViewLimit: _.random(11, 21),
        },
        {
          counter: 45,
          target: _.random(0, 2),
          viewCount: 0,
          colors: _.shuffle(this.colors).slice(0, 3),
          min: 13,
          max: 23,
          maxViewLimit: _.random(13, 23),
        },
        {
          counter: 60,
          target: _.random(0, 3),
          viewCount: 0,
          colors: _.shuffle(this.colors).slice(0, 4),
          min: 15,
          max: 25,
          maxViewLimit: _.random(15, 25),
        },
        {
          counter: 60,
          target: _.random(0, 3),
          viewCount: 0,
          colors: _.shuffle(this.colors).slice(0, 4),
          min: 15,
          max: 28,
          maxViewLimit: _.random(15, 28),
        },
        {
          counter: 75,
          target: _.random(0, 4),
          viewCount: 0,
          colors: _.shuffle(this.colors).slice(0, 5),
          min: 19,
          max: 33,
          maxViewLimit: _.random(19, 33),
        },
        {
          counter: 90,
          target: _.random(0, 5),
          viewCount: 0,
          colors: _.shuffle(this.colors).slice(0, 6),
          min: 21,
          max: 41,
          maxViewLimit: _.random(21, 41),
        },
      ];

      this.currentColor = this.levels[this.level - 1].colors.filter(
        (k, index) => index != this.levels[this.level - 1].target
      )[0];
    },
    initQuestionMode() {
      this.questionInterval = setInterval(() => {
        if (this.pause) return;
        this.questionCounter -= 1;
        this.$root.$emit("pause", false);
        if (this.questionCounter == 0) {
          this.$root.$emit("pause", true);
          this.questionStatus = "end";
          clearInterval(this.interval);
          clearInterval(this.questionInterval);
          this.questionInterval = null;
          this.interval = null;
          var isPlus = _.random(0, 1) == 1;

          this.options.push({
            option: this.levels[this.level - 1].viewCount,
            isTrue: true,
            picked: false,
          });

          this.options.push({
            option: this.levels[this.level - 1].viewCount - 2,
            isTrue: false,
            picked: false,
          });

          this.options.push({
            option: this.levels[this.level - 1].viewCount + 1,
            isTrue: false,
            picked: false,
          });

          this.options.push({
            option: this.levels[this.level - 1].viewCount - 1,
            isTrue: false,
            picked: false,
          });
          this.options.push({
            option: this.levels[this.level - 1].viewCount - 3,
            isTrue: false,
            picked: false,
          });

          this.options = _.shuffle(this.options);
        }
      }, 1000);
    },
    start() {
      this.step = 1;
      this.maxStep = this.directions[this.direction].length;
      if (this.questionMode == 1) {
        this.questionStatus = "started";
        this.questionCounter = this.levels[this.level - 1].counter;
        this.initQuestionMode();
      }
      this.interval = setInterval(() => {
        if (this.pause) return;
        if (this.questionMode == 1) {
          var level = this.levels[this.level - 1];

          if (level.viewCount <= level.max) {
            var n = _.random(0, level.colors.length - 1);
            this.currentColor = level.colors[n];
          } else {
            if (this.currentColor == level.colors[level.target]) {
              var n = _.random(0, level.colors.length - 1);
              while (true) {
                if (level.target == n) {
                  n = _.random(0, level.colors.length - 1);
                } else {
                  this.currentColor = level.colors[n];
                  break;
                }
              }
            }
          }

          var timePercent =
            (this.questionCounter / this.levels[this.level - 1].counter) * 100;
          var pickPercent =
            (this.levels[this.level - 1].viewCount /
              this.levels[this.level - 1].maxViewLimit) *
            100;
          pickPercent = 100 - pickPercent;

          if (Math.abs(pickPercent - timePercent) > 15) {
            while (true) {
              var n = _.random(
                0,
                this.levels[this.level - 1].colors.length - 1
              );
              if (n != this.levels[this.level - 1].target) {
                break;
              }
            }
            this.currentColor = level.colors[n];
          }

          if (this.currentColor == level.colors[level.target]) {
            this.levels[this.level - 1].viewCount += 1;
          }
        }

        this.$store.state.ticks[this.$store.state.selectedTick2].play();
        this.step += 1;
        if (this.step == this.maxStep) {
          this.step = 1;
          this.tourCount += 1;
        }
      }, this.speeds[this.speed - 1]);
    },
  },
  watch: {
    speed: function () {
      if (this.questionMode == 1) {
        return;
      }
      clearInterval(this.interval);
      this.interval = null;
      this.step = 1;
      this.start();
    },
    direction: function () {
      this.maxStep = this.directions[this.direction].length;
    },
    questionMode: function () {
      this.questionStatus = "wait";
      clearInterval(this.interval);
      clearInterval(this.questionInterval);
      this.interval = null;
      this.questionInterval = null;
      this.step = 1;
      if (this.questionMode == 0) {
        this.start();
      } else {
        this.initLevels();
      }
    },
    step: function () {
      if (
        this.step == this.maxStep - 1 &&
        this.autoLevel == 1 &&
        this.questionMode == 0
      ) {
        this.speed = Math.min(this.speed + 1, this.speeds.length);
      }
    },
    tourCount: function () {
      if (this.autoLevel == 1) {
        if (this.tourCount % 2 == 0) {
          if (this.direction == "dikey") {
            this.direction = "yatay";
          } else {
            this.direction = "dikey";
          }
        }
      }
    },
    answerStack: {
      deep: true,
      handler: function () {
        if (this.autoLevel == 0) return;
        if (this.answerStack.filter((k) => k == true).length == 2) {
          this.answerStack = this.answerStack.filter((k) => k == false);
          this.level = Math.min(this.level + 1, this.levels.length - 1);
          this.speed = Math.min(this.speed + 1, this.speeds.length);
        }
        if (this.answerStack.filter((k) => k == false).length == 2) {
          this.answerStack = this.answerStack.filter((k) => k == true);
          this.level = Math.max(this.level - 1, 1);
          this.speed = Math.max(this.speed - 1, 1);
        }
      },
    },
  },
  computed: {
    top() {
      return this.directions[this.direction][this.step - 1].top;
    },
    left() {
      return this.directions[this.direction][this.step - 1].left;
    },
  },
  created() {
    if (this.config != null && this.config != undefined) {
      if (this.config.speed != null && this.config.speed != "")
        this.speed = this.config.speed;
      if (this.config.direction != null && this.config.direction != "")
        this.direction = this.config.direction;
      if (this.config.autoLevel != null && this.config.autoLevel != "")
        this.autoLevel = this.config.auto_level;

      if (this.config.questionMode != null && this.config.questionMode != "") {
        this.questionMode = this.config.questionMode;
      }
      if (
        this.config.questionModeLevel != null &&
        this.config.questionModeLevel != ""
      )
        this.level = this.config.questionModeLevel;
    }

    if (this.questionMode == 1) {
      this.$root.$emit("pause", true);
    }
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  max-width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/ZikZak.vue